import { render, staticRenderFns } from "./RecordMsg.vue?vue&type=template&id=87314d8c&"
import script from "./RecordMsg.vue?vue&type=script&lang=js&"
export * from "./RecordMsg.vue?vue&type=script&lang=js&"
import style0 from "./RecordMsg.vue?vue&type=style&index=0&id=87314d8c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports